export enum ETagType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
